import httpClient from "./httpClient";

export function listRoles() {
  return httpClient.get("/roles").then((res) => res.data.data);
}

export function createRole(payload) {
  return httpClient.post("/roles", payload).then((res) => res.data.data);
}

export function updateRole(id, payload) {
  return httpClient.put(`/roles/${id}`, payload).then((res) => res.data.data);
}

export function deleteRole(id) {
  return httpClient.delete(`/roles/${id}`).then((res) => res.data);
}
